(() => {
  if (customElements.get('lm-ingredient-parallax')) return;
  class IngredientParallax extends HTMLElement {
    connectedCallback() {
      this.stage = this.querySelector('.lm-ip__stage');
      this.layers = [...this.querySelectorAll('[data-depth]')];
      this.media = matchMedia('(prefers-reduced-motion: reduce)');
      this.pointer = {x:0,y:0};
      this.visible = false;
      this.animations = [];
      this.entered = false;
      this.layers.forEach((layer,i) => {
        layer.style.setProperty('--duration',`${4.5+i*.65}s`);
        layer.style.setProperty('--delay',`${-i*1.3}s`);
        layer.style.setProperty('--float',`${Number(this.dataset.energy || 12)*(innerWidth<750?.5:1)}px`);
      });
      this.enter = () => {
        if (this.entered || this.media.matches) return;
        this.entered = true;
        this.layers.forEach((layer,i) => {
          const side = Number(layer.dataset.x)<50?-1:1;
          this.animations.push(layer.querySelector('.lm-ip__entrance').animate([
            {opacity:0,transform:`translate(${side*55}px,45px) scale(.65) rotate(${side*12}deg)`},
            {opacity:1,transform:'translate(0,-9px) scale(1.06) rotate(0deg)',offset:.72},
            {opacity:1,transform:'translate(0,0) scale(1) rotate(0deg)'}
          ],{duration:850,delay:i*130,easing:'cubic-bezier(.22,.7,.3,1)',fill:'backwards'}));
        });
      };
      this.tick = () => {
        this.frame = 0;
        if (!this.visible || this.media.matches) return;
        const rect = this.stage.getBoundingClientRect();
        const progress = Math.max(-1,Math.min(1,(innerHeight/2-rect.top-rect.height/2)/((innerHeight+rect.height)/2)));
        const factor = innerWidth<750?.35:1;
        this.layers.forEach(layer => {
          const depth = Number(layer.dataset.depth)*factor;
          const motion = layer.querySelector('.lm-ip__motion');
          motion.style.setProperty('--mx',`${this.pointer.x*depth*.25}px`);
          motion.style.setProperty('--my',`${progress*depth+this.pointer.y*depth*.2}px`);
        });
      };
      this.schedule = () => {if (!this.frame && this.visible) this.frame=requestAnimationFrame(this.tick);};
      this.move = event => {
        if (this.dataset.mouse!=='true' || event.pointerType!=='mouse' || !matchMedia('(hover:hover) and (pointer:fine)').matches) return;
        const r=this.stage.getBoundingClientRect();
        this.pointer={x:(event.clientX-r.left)/r.width*2-1,y:(event.clientY-r.top)/r.height*2-1};this.schedule();
      };
      this.leave = () => {this.pointer={x:0,y:0};this.schedule();};
      this.click = event => {
        const button=event.target.closest('.lm-ip__trigger');if(!button)return;
        const pressed=button.getAttribute('aria-pressed')==='true';
        this.querySelectorAll('.lm-ip__trigger').forEach(b=>b.setAttribute('aria-pressed','false'));
        button.setAttribute('aria-pressed',String(!pressed));
      };
      this.change = () => {
        this.animations.forEach(a=>a.cancel());
        this.layers.forEach(l=>l.querySelector('.lm-ip__motion').removeAttribute('style'));
        this.schedule();
      };
      this.observer=new IntersectionObserver(entries=>{
        this.visible=entries[0].isIntersecting;
        this.dataset.active=String(this.visible && !document.hidden);
        if(this.visible){this.enter();this.schedule();}
        this.animations.forEach(a=>{if(a.playState==='finished')return;if(this.visible&&!document.hidden)a.play();else a.pause();});
      },{threshold:.15});
      this.observer.observe(this);
      this.visibility = () => {
        this.dataset.active=String(this.visible&&!document.hidden);
        this.animations.forEach(a=>{if(a.playState==='finished')return;if(this.visible&&!document.hidden)a.play();else a.pause();});
      };
      document.addEventListener('visibilitychange',this.visibility);
      addEventListener('scroll',this.schedule,{passive:true});addEventListener('resize',this.schedule,{passive:true});
      this.addEventListener('pointermove',this.move);this.addEventListener('pointerleave',this.leave);this.addEventListener('click',this.click);
      this.media.addEventListener('change',this.change);
    }
    disconnectedCallback() {
      this.observer?.disconnect();cancelAnimationFrame(this.frame);this.animations?.forEach(a=>a.cancel());
      document.removeEventListener('visibilitychange',this.visibility);
      removeEventListener('scroll',this.schedule);removeEventListener('resize',this.schedule);
      this.removeEventListener('pointermove',this.move);this.removeEventListener('pointerleave',this.leave);this.removeEventListener('click',this.click);
      this.media?.removeEventListener('change',this.change);
    }
  }
  customElements.define('lm-ingredient-parallax',IngredientParallax);
})();
